import { combineLatest, Observable, of, Subject } from 'rxjs';
import { catchError, map, shareReplay, switchMap, tap } from 'rxjs/operators';
import { DataService } from 'src/app/services/data.service';
import { HelpService } from 'src/app/services/help.service';
import { SwiperContainer } from 'swiper/element';

import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { InAppBrowserOptions } from '@awesome-cordova-plugins/in-app-browser';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { SuscriptionService, UserService } from '@core/services';
import { Platform } from '@ionic/angular';
import { Suscription, SuscriptionDaily, User } from '@shared/models';

@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
})
export class HomePage {
  @ViewChild('swiper') swiper!: ElementRef<SwiperContainer>;

  private refreshSubject = new Subject<void>();
  user$: Observable<User | null>;
  suscription$: Observable<Suscription>;
  suscriptions$: Observable<Suscription[]> = this.refreshSubject.asObservable().pipe(
    switchMap(() => this.getSuscriptions()),
    tap(() => this.slideTo()),
    shareReplay({ bufferSize: 1, refCount: false })
  );
  nextSuscriptions$: Observable<Suscription[]>;
  suscriptionUrl$: Observable<string | null>;

  type = 'roundtrip';
  subscription: Suscription | null = null;
  subscribable = false;
  iabOptions: InAppBrowserOptions = {
    location: 'no',
    hidenavigationbuttons: 'yes',
    toolbarposition: 'bottom',
    toolbarcolor: '#0e53a1',
    navigationbuttoncolor: '#ffffff',
    hideurlbar: 'yes',
    closebuttoncaption: 'Cerrar',
  };

  constructor(
    private router: Router,
    private iab: InAppBrowser,
    private dataService: DataService,
    private platform: Platform,
    private userService: UserService,
    private suscriptionService: SuscriptionService,
    private helpService: HelpService
  ) {
    this.user$ = this.userService.user$;
    this.suscription$ = this.suscriptionService.suscription$;
    this.nextSuscriptions$ = combineLatest([this.suscription$, this.suscriptions$]).pipe(
      map(([suscription, suscriptions]) => suscriptions.filter((s) => s.id !== suscription?.id))
    );
    this.suscriptionUrl$ = this.suscription$.pipe(map((suscription) => this.getSuscriptionUrl(suscription)));
  }

  ionViewDidEnter() {
    this.suscriptionService.updateSuscription();
    this.refreshSubject.next();
  }

  private getSuscriptions(): Observable<Suscription[]> {
    return this.suscriptionService.getSuscriptions().pipe(
      catchError(() => of([])),
      shareReplay({ bufferSize: 1, refCount: false })
    );
  }

  openSuscriptions() {
    this.router.navigate(['/tecservice-transportec/transportec/subscription/list']);
  }

  goSubscribe(suscription: Suscription, suscriptionUrl: string | null) {
    if (suscriptionUrl) {
      this.dataService.setData('subscription', suscription);
      this.router.navigate([suscriptionUrl]);
    }
  }

  getSuscriptionUrl(suscription: Suscription): string | null {
    // If suscription status is not 0 means that is not suscribable
    if (suscription?.status !== 0) {
      return null;
    }

    if (this.suscriptionService.isExtraRegistrationOpen() || this.suscriptionService.isResetSuscribable()) {
      return '/tecservice-transportec/transportec/selection';
    }

    return '/tecservice-transportec/subscription/subscribe-radial-options';
  }

  slideTo() {
    const swiperInstance = this.swiper?.nativeElement.swiper;
    if (!swiperInstance) {
      setTimeout(() => {
        this.slideTo();
      }, 100);
      return;
    }
    let dow = new Date().getDay() - 1;
    if (dow > 5) {
      dow = 0;
    }
    swiperInstance?.slideTo(dow);
  }

  goRoutes() {
    console.log('goRoutes');
    this.router.navigate(['/tecservice-transportec/transportec/routes']);
  }

  goZones() {
    console.log('goZones');
    this.router.navigate(['/tecservice-transportec/transportec/zones']);
  }

  goSubscription(item: SuscriptionDaily) {
    console.log('goSubscription');
    this.dataService.setData(item.id, item);
    this.router.navigate(['/tecservice-transportec/transportec/subscription/' + item.id]);
  }

  goTickets() {
    console.log('goTickets');
    this.router.navigate(['/tecservice-transportec/transportec/tickets']);
  }

  goRides() {
    this.router.navigate(['/tecservice-transportec/transportec/rides-history']);
  }

  goHelp() {
    this.helpService.presentTicketsTutorialMenu();
  }
}
